module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "reg-container"
  }, [_c('el-form', {
    ref: "regForm",
    staticClass: "reg-form",
    attrs: {
      "model": _vm.regForm,
      "rules": _vm.regRules
    }
  }, [_c('div', {
    staticClass: "reg-Title row1"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/icon/ic_soc.png"),
      "alt": "S"
    }
  }), _vm._v("\n        Group E-learning\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "reg-Title row2"
  }, [_vm._v("\n        註冊帳號\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "請輸入姓名"
    },
    model: {
      value: (_vm.regForm.name),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "name", $$v)
      },
      expression: "regForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "請輸入工號"
    },
    model: {
      value: (_vm.regForm.id),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "id", $$v)
      },
      expression: "regForm.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "請輸入Email"
    },
    model: {
      value: (_vm.regForm.email),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "email", $$v)
      },
      expression: "regForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dep"
    }
  }, [_c('el-cascader', {
    staticClass: "filter-select",
    attrs: {
      "placeholder": "請選擇部門",
      "show-all-levels": false,
      "options": _vm.filter.actualDeps.options
    },
    on: {
      "change": _vm.actualDepsSelect
    },
    model: {
      value: (_vm.filter.actualDeps.selected),
      callback: function($$v) {
        _vm.$set(_vm.filter.actualDeps, "selected", $$v)
      },
      expression: "filter.actualDeps.selected"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "level"
    }
  }, [_c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "placeholder": "請選擇師級"
    },
    on: {
      "change": _vm.levelSelect
    },
    model: {
      value: (_vm.filter.level.selected),
      callback: function($$v) {
        _vm.$set(_vm.filter.level, "selected", $$v)
      },
      expression: "filter.level.selected"
    }
  }, _vm._l((_vm.filter.level.selectedFilters), function(selectedFilter) {
    return _c('el-option', {
      key: selectedFilter.value,
      attrs: {
        "label": selectedFilter.text,
        "value": selectedFilter.value
      }
    }, [_vm._v(_vm._s(selectedFilter.text))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPass ? 'text' : 'password',
      "auto-complete": "off",
      "placeholder": "請輸入密碼"
    },
    model: {
      value: (_vm.regForm.pwd),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "pwd", $$v)
      },
      expression: "regForm.pwd"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "right": "1rem",
      "top": "0.5rem",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass = !_vm.showPass
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPass2 ? 'text' : 'password',
      "auto-complete": "off",
      "placeholder": "請再次輸入密碼"
    },
    model: {
      value: (_vm.regForm.pwd2),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "pwd2", $$v)
      },
      expression: "regForm.pwd2"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "right": "1rem",
      "top": "0.5rem",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass2 ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass2 ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass2 = !_vm.showPass2
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n            送出申請\n        ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a28e629a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register.vue
// module id = 949
// module chunks = 170